import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ErrorBannerProps {
  error: string | null;
  onDismiss: () => void;
  className?: string;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  error,
  onDismiss,
  className = '',
}) => {
  const { t } = useTranslation();

  if (!error) return null;

  return (
    <div
      className={`mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2 ${className}`}
    >
      <AlertCircle className="w-5 h-5 text-red-500" />
      <span className="text-red-700">{error}</span>
      <button
        onClick={onDismiss}
        className="ml-auto text-red-500 hover:text-red-700"
        aria-label={t('tools.errorBanner.dismiss')}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
